export default __webpack_public_path__ + "static/media/right-arrow-hover.1dec0bce.svg";